import { IDeviceNavigator } from "../device";

export interface IDeviceStatusSummary {
    device: IDeviceNavigator;
    imei: string;
    qrCode: string;
    lastUpdate: Date;
}
